import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveCreds } from 'common/axios/jwt';
import { LoadingSpin } from 'common/components';
import { ERoutesCommon } from 'common/models/routesModel';
import { markFreshLogin } from 'common/hooks/RewardsPopup.hooks';
import { useAppDispatch } from 'app/store/store.hooks';
import { refreshToken, updateIsSocialNetworkRegistered } from 'app/store/reducers/auth.reducer';

export const SocialAuthPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('userId');
    const access = params.get('access');
    const refresh = params.get('refresh');
    const isRegisteredData = params.get('isRegistered');
    const issuedAt = new Date().getTime();
    const expiredAt = new Date().getTime();
    const isRegistered = isRegisteredData === 'true';

    if (userId && access && refresh) {
      // set flag for reward popup
      markFreshLogin();

      const token = {
        id: userId,
        userId,
        issuedAt,
        expiredAt,
        token: refresh,
      };

      saveCreds({
        refresh: token,
        access: token,
      });
      dispatch(updateIsSocialNetworkRegistered(!!isRegistered));
      dispatch(refreshToken(refresh));
    } else {
      navigate(ERoutesCommon.Root);
    }
  }, []);

  return <LoadingSpin />;
};
